import template from './attr-edit.html';

const ToNumber = (val) => {
  const fVal = parseFloat(val);
  return isNaN(fVal) ? undefined : fVal;
};
class AttrEditController {
  constructor(tagsService) {
    'ngInject';

    this.placeHolder = '';
    this.emptyValue = { value: '' };
    this.tagsService = tagsService;
  }

  $onInit() {}

  handleOnSubmit(value, invalid) {
    if (this.onSubmit) this.onSubmit({ key: this.attr.key, value, invalid });
  }

  handleOnChange(value, invalid) {
    if (this.onChange) this.onChange({ key: this.attr.key, value, invalid });
    if (this.elmType === 'select' && this.onSubmit)
      this.onSubmit({ key: this.attr.key, value, invalid });
  }

  $onChanges(changes) {
    if (!this.attr) return;
    const inputTypeMap = { text: 'text', integer: 'number', decimal: 'number', hyperlink: 'url' };
    const { dataType, freeform, key, range, values } = this.attr;
    const { min = undefined, max = undefined } = range || {};
    const type = dataType?.toLowerCase() || 'text';

    this.inputType = inputTypeMap[type] || 'text';
    this.inputMin = undefined;
    this.inputMax = undefined;
    this.help = this.tagsService.getAttrShortHelpText(this.attr);
    const options = (values || [])
      .map((v) => ({ normalizeV: v.value?.toLowerCase(), value: v.value }))
      .sort();

    this.options = [this.emptyValue, ...options];
    if (this.inputType === 'number') {
      this.inputMin = ToNumber(min);
      this.inputMax = ToNumber(max);
    }
    this.attrValue = this.inputType === 'number' ? ToNumber(this.attrValue) : this.attrValue;

    this.elmType = 'input';
    switch (type) {
      case 'text':
      case 'hyperlink':
        this.elmType = freeform ? 'input' : 'select';
        this.selectModel = { normalizeV: this.attrValue?.toLowerCase(), value: this.attrValue };
        break;
      case 'integer':
        this.inputPattern = '^[+-]?[0-9]+$';
        break;
      case 'decimal':
        this.inputPattern = /^[+-]?(\d+\.?\d*|\.\d+)$/;
        break;
      default:
        this.elmType = 'input';
    }
  }
}

export default {
  template,
  controller: AttrEditController,
  controllerAs: 'vm',
  bindings: {
    attr: '<',
    attrValue: '<',
    onChange: '&?',
    onSubmit: '&?',
  },
};
